/**
 * Contrat de suppression en masse partagé API ↔ Web.
 *
 * Les référentiels (transporteurs, sites logistiques, donneurs d'ordres,
 * lieux) exposent tous `POST /:resource/bulk-delete`. La réponse est
 * volontairement **partielle** : une ligne peut résister à la suppression
 * (déjà supprimée par un autre onglet, contrainte métier), et l'appelant doit
 * pouvoir distinguer « tout est parti » de « 12 sur 1960 ont résisté » plutôt
 * que de recevoir un 500 qui masque le succès des autres.
 */

/** Borne haute d'un appel : au-delà, l'appelant découpe en plusieurs lots. */
export const BULK_DELETE_MAX_IDS = 5000;

/** Une ligne qui n'a pas pu être supprimée, avec la raison à afficher. */
export interface BulkDeleteFailure {
  id: string;
  reason: string;
}

/** Corps de `POST /:resource/bulk-delete`. */
export interface BulkDeleteDto {
  ids: string[];
}

/** Réponse de `POST /:resource/bulk-delete`. */
export interface BulkDeleteResult {
  /** Nombre de lignes effectivement supprimées. */
  deleted: number;
  /** Lignes restées en place — vide quand tout est passé. */
  failed: BulkDeleteFailure[];
}
